<div class="w-full px-4 py-4">
  <div class="mb-4">
    <aw-section-headline size="medium">
      {{ cmsTextProvider.shared.designPreview }}
    </aw-section-headline>
  </div>

  <aw-ticket-tile
    id="ticket-preview"
    [buttonTextOverride]="buttonText()"
    [ticket]="previewTicket()" />
</div>
